import { GridColDef } from "@mui/x-data-grid";
import CityDetailButton from "./DetailButton";

export const purchaseColumns: GridColDef[] = [
  {
    field: "creatorId",
    headerName: "Oluşturan",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "isConsumed",
    headerName: "Tüketildi",
    flex: 1,
    minWidth: 80,
    type: "boolean",
  },
  {
    field: "productId",
    headerName: "Ürün",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "orderId",
    headerName: "Sipariş Id",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "lastModificationTime",
    headerName: "Değiştirilme Tarihi",
    type: "dateTime",
    flex: 1,
    minWidth: 80,
    valueGetter: (v, r) => new Date(v),
  },
  {
    field: "creationTime",
    headerName: "Oluşturulma Tarihi",
    type: "dateTime",
    flex: 1,
    minWidth: 80,
    valueGetter: (v, r) => new Date(v),
  },
];
